import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DestroyComponent } from './components/destroy/destroy.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DestroyComponent],
})
export class NgUtilsModule {}
